module.exports = __webpack_public_path__ + "static/media/ticketack_viewer_icon.fcf0ad40.png";